import type { SxProps, Theme } from "@mui/material"

import type { MuiScatterConfig } from "types/muiScatter.types"

export const getStyles = (config: MuiScatterConfig): SxProps<Theme> => {
  const highlightedStyles = Object.fromEntries(
    config.series.map((series) => [
      `& [data-series='${series.id}'] [data-highlighted=true]`,
      {
        stroke: series.color,
        strokeWidth: 2.5,
      },
    ]),
  )

  return {
    "&& .MuiChartsAxis-line, && .MuiChartsAxis-tick": {
      stroke: config.axisColor,
    },
    "& .MuiChartsGrid-line": config.gridStyle,
    ...highlightedStyles,
  }
}
